import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-style",
  templateUrl: "./med-icon-border-style.component.html",
})
export class MedIconBorderStyleComponent extends SvgMixinComponent {}
